import { FeeStructure } from './';

export default {
  path: 'fee',
  childRoutes: [
    { path: '', component: FeeStructure, isIndex: true }
  ]
};